import { render, staticRenderFns } from "./RequestFormComponent.vue?vue&type=template&id=1df7bb8e"
import script from "./RequestFormComponent.vue?vue&type=script&lang=js"
export * from "./RequestFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports